module.exports = __webpack_public_path__ + "static/img/i101.06c4e2a0.png";